import { Icon } from "@blueprintjs/core";

import { Checkbox } from "@/components/pieces/form/Checkbox";
import { Clickable } from "@/components/pieces/interaction/Clickable";
import { CARD_CLASSES } from "@/css/constants";
import { EvaluationCriterionFieldsFragment } from "@/graphql";

interface PreviewCriterionItemProps {
  criterion: EvaluationCriterionFieldsFragment;
  isSelected: boolean;
  onToggleSelection: (id: string) => void;
}

export function PreviewCriterionItem({
  criterion,
  isSelected,
  onToggleSelection,
}: PreviewCriterionItemProps) {
  return (
    <Clickable onClick={() => onToggleSelection(criterion.id)}>
      <div
        className={`flex flex-col gap-4 rounded-md border bg-white p-5 ${CARD_CLASSES} ${isSelected ? "border-blue-700" : "border-border"}`}
      >
        <div className="flex items-center">
          <Checkbox
            checked={isSelected}
            onChange={() => onToggleSelection(criterion.id)}
            hasBorders={false}
            style={{ fontSize: 18, fontWeight: 600 }}
          />
          <div className="text-lg font-semibold">{criterion.name}</div>
        </div>
        <div className="flex flex-col gap-4 pl-8">
          {criterion?.items?.map((item) => (
            <div key={item?.id} className="flex">
              <span className="text-green-700">
                <Icon icon="tick" color="currentColor" />
              </span>
              <div className="ml-3 flex-1">{item?.name}</div>
            </div>
          ))}
        </div>
      </div>
    </Clickable>
  );
}
